export default string => string.replace(/(<p[^>]+?>|<p>|<\/p>)/gim, '')
